// @flow
import { call, put, takeLatest } from "redux-saga/effects";
import API from "api";

import * as ActionTypes from "constants/ActionTypes";
import * as Actions from "actions";

function* adminGetShopVirtualTryOns(action: Object) {
  try {
    const { shopId, params } = action;
    const response = yield call(() =>
      API.get(`/admin/virtual-tryon/shop/${shopId}`, { params }),
    );
    yield put(Actions.adminGetShopVirtualTryOnsSuccess(response));
  } catch (error) {
    yield put(Actions.adminGetShopVirtualTryOnsFailure(error));
  }
}

export default function* watchAdminVirtualTryOns() {
  yield takeLatest(
    ActionTypes.ADMIN_GET_SHOP_VIRTUAL_TRYONS_START,
    adminGetShopVirtualTryOns,
  );
}

